import request from '../util/http'

export const queryVerifyByGuarantee = (id) => {
  return request({
    url: '/zcjf/biz/guarantee/order/viewGuarantee3',
    method: 'get',
    params: {
      guaranteeNo: id,
    },
  })
}

export const viewPerformanceRecord = (id) => {
  return request({
    url: '/zcjf/biz/guarantee/order/viewPerformanceRecord',
    method: 'get',
    params: {
      guaranteeNo: id,
    },
  })
}
